import gql from 'graphql-tag';
import { WalletFragment } from '../fragments/wallet.fragment';

export const FIND_OR_CREATE_AGENT_WALLET = gql`
    mutation(
        $userId: String!
    ) {
        findOrCreateAgentCreditWallet(
            userId: $userId
        ) {
            ...WalletInfo
        }
    }
    ${WalletFragment}
`;